export const EMPLOYEE_DOCUMENT_DROP_DOWN_ITEMS = []